// src/Login/login.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import logo from "../Assets/logo.png";

const VALID_USER = "donnarosemarmitaria";
const VALID_PASS = "123456";
const AUTH_KEY = "pd_auth_v1";

export default function Login() {
  // ✅ já começa preenchido
  const [usuario, setUsuario] = useState(VALID_USER);
  const [senha, setSenha] = useState("");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");
    setLoading(true);

    await new Promise((r) => setTimeout(r, 200));

    const userOK = usuario.trim().toLowerCase() === VALID_USER;
    const passOK = senha === VALID_PASS;

    if (userOK && passOK) {
      localStorage.setItem(
        AUTH_KEY,
        JSON.stringify({ u: VALID_USER, ts: Date.now() })
      );
      navigate("/uploads-images", { replace: true });
    } else {
      setErro("Usuário ou senha inválidos.");
      setLoading(false);
    }
  };

  return (
    <div className="login-root">
      <div className="bg-animated" aria-hidden />

      <main className="login-wrapper">
        <header className="brand">
          <img src={logo} alt="Donna Rose Marmitaria" className="brand-logo" />
          <h1 className="title">Prato do Dia | Donna Rose Marmitaria</h1>
        </header>

        <section className="card">
          <h2 className="card-title">Acesso</h2>

          <form onSubmit={handleSubmit} className="form" autoComplete="off">
            <label className="label" htmlFor="usuario">
              Informe o usuário
            </label>
            <input
              id="usuario"
              className="input"
              type="text"
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
              required
              autoComplete="username"
              // autoFocus removido para focar direto na senha
            />

            <label className="label" htmlFor="senha">
              Informe a senha
            </label>
            <div className="password-wrap">
              <input
                id="senha"
                className="input input-password"
                type={mostrarSenha ? "text" : "password"}
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
                autoComplete="current-password"
                autoFocus
              />
              <button
                type="button"
                className="toggle-pass"
                onClick={() => setMostrarSenha((v) => !v)}
                aria-label={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
                title={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
              >
                {mostrarSenha ? "🙈" : "👁️"}
              </button>
            </div>

            {erro && (
              <div className="error" role="alert" aria-live="assertive">
                {erro}
              </div>
            )}

            <button className="btn" type="submit" disabled={loading}>
              {loading ? "Entrando..." : "Entrar"}
            </button>
          </form>

          <p className="hint">
            <strong>Dica:</strong> usuário <code>{VALID_USER}</code>, senha{" "}
            <code>{VALID_PASS}</code>
          </p>

          <footer className="footer">
            <small>© {new Date().getFullYear()} Donna Rose Marmitaria</small>
          </footer>
        </section>
      </main>
    </div>
  );
}
